import { AsyncAction } from './AsyncAction.js';
import { AsyncScheduler } from './AsyncScheduler.js';
export const asyncScheduler = new AsyncScheduler(AsyncAction);
//# sourceMappingURL=async.js.map